package chat.amp.tim

import de.connect2x.messenger.compose.view.roomlist.RoomListContainerView
import de.connect2x.messenger.compose.view.roomlist.room.RoomListElementContainerView
import de.connect2x.messenger.compose.view.theme.ThemeComponents
import de.connect2x.trixnity.messenger.util.DownloadManager
import kotlinx.coroutines.CoroutineScope
import org.koin.dsl.module

fun ampModule() = module {
    single<RoomListElementContainerView> { ampRoomListElementContainerViewImpl() }
    single<RoomListContainerView> { ampRoomListContainerViewImpl() }

    // The component set is a brand switch; MESSENGER leaves the library's own styling in
    // place. The room list container above stays registered either way, it draws the logos.
    when (Brand.features.themeComponents) {
        ThemeComponentSet.MESSENGER -> {}
        ThemeComponentSet.CHERRY -> single<ThemeComponents> { ampThemeComponentsImpl() }
        ThemeComponentSet.FLAT -> single<ThemeComponents> { ampThemeComponentsFlatImpl() }
    }

    // Content scanning is a per brand switch, see brands/<id>/brand.toml.
    if (Brand.features.contentScanning) {
        single<DownloadManager> { ampDownloadManagerImpl(get<CoroutineScope>().coroutineContext) }
    }
}
